import React, { useState } from "react";
import "./login.scss";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../../ProtectedRoute/AuthContext";

function Login() {
  const navigate = useNavigate();
  const { handleLogin } = useAuth();
  const [adminUser, setAdminUser] = useState({
    email: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState(false); // Loading state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdminUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading

    const url = `https://ballersapi.ballerslife.co/api/v1/admin/admin_login?email=${adminUser.email}&password=${adminUser.password}`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(adminUser),
      });
      const data = await response.json();

      if (response.ok) {
        handleLogin(data.access_token, data.flag);
        setAdminUser({
          email: "",
          password: "",
        });
        toast.success("Login Successful");
        navigate("/admin/facility");
      } else {
        toast.error("Incorrect Credentials");
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      toast.error("Login Failed");
    } finally {
      setIsLoading(false); // Stop loading
    }
  };
  //
  return (
    <div className="adminLoginMain">
      <div className="navbar">
        <div onClick={() => navigate("/")} className="adminCenterLogo">
          <div className="logo"></div>
          <div className="name"></div>
        </div>
      </div>
      <div>
        <div>
          <div className="adminLoginFormMain">
            <div className="adminLoginForm">
              <p className="adminTag">Admin Login</p>
              <form className="adminFormInput" onSubmit={handleSubmit}>
                <div className="adminInputMain">
                  <p>Email</p>
                  <input
                    type="email"
                    name="email"
                    className="adminInputField"
                    placeholder="Enter your Email Address"
                    value={adminUser.email}
                    onChange={handleChange}
                    disabled={isLoading} // Disable input when loading
                  />
                </div>
                <div className="adminInputMain">
                  <p>Password</p>
                  <input
                    type="password"
                    name="password"
                    className="adminInputField"
                    placeholder="Enter your Password"
                    value={adminUser.password}
                    onChange={handleChange}
                    disabled={isLoading} // Disable input when loading
                  />
                </div>
                <button
                  className="adminSubBtn"
                  type="submit"
                  disabled={isLoading} // Disable button when loading
                >
                  {isLoading ? "Getting Started..." : "Get Started"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
